import axios from "axios";
import {
  AB_CONFIG_SET,
  AB_CONFIG_FETCH_FAILED
} from "../../constants/ActionTypes";
import { SERVER_URL } from '../../constants/ClientConfig';
import { AB_CONFIG_KEYS } from "../../constants/AbConfigKeys";
import isEmpty from "lodash/isEmpty";
import { generateId, getCookie } from "../../utils/trainUtils";
import { POKUS_WEB_LOCAL_STORAGE_KEY } from "../../constants/Constants";

export const fetchAbConfig = () => {
  const traceId = generateId();
  return async (dispatch) => {
    if (isEmpty(AB_CONFIG_KEYS)) {
      return;
    }
    const mmtAuth = getCookie("mmt-auth") || "";
    const headers = { "X-Trace-Id": traceId, mmtauth: mmtAuth };
 
    try {
      const res = await axios.post(`${SERVER_URL}/getAbConfig`, {
        ...AB_CONFIG_KEYS,
      }, { headers });
 
      if (res.data.success) {
        dispatch({
          type: AB_CONFIG_SET,
          payload: res.data
        });
      } else {
        throw new Error("Error in fetching AB Keys");
      }
    } catch (err) {
      dispatch({
        type: AB_CONFIG_FETCH_FAILED
      });
    }
  }
};

export const fetchAbConfigLocalStorage = () => {
  return dispatch => {
    dispatch({
      type: AB_CONFIG_SET,
      payload: JSON.parse(localStorage.getItem(POKUS_WEB_LOCAL_STORAGE_KEY))
    });
  };
};
